import React from 'react';

import Reply from '../RepliesList/Reply';

const RepliesListLoading = () => {

  return (
    <div>
      <Reply isEmpty />
      <Reply isEmpty />
      <Reply isEmpty />
    </div>
  );
};


export default RepliesListLoading;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/RepliesListLoading/index.js
 **/